if (!customElements.get('collection-infinite-scroll')) {
  customElements.define('collection-infinite-scroll', class extends HTMLElement {
    connectedCallback() {
      this.link = this.querySelector('a');
      this.status = this.querySelector('[role="status"]');
      this.grid = this.closest('.collection').querySelector('#product-grid');
      this.buffer = [];
      this.cancelled = false;
      this.stage(Array.from(this.grid.children).filter((item) => item.dataset.resultId || item.dataset.productId));
      this.observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) this.load();
      }, { rootMargin: '200px 0px' });
      this.updateLink();
      this.onClick = (event) => {
        if (this.catalog ? !this.catalog.hasMore : !this.dataset.nextUrl && !this.buffer.length) return;
        event.preventDefault(); this.load();
      };
      this.link.addEventListener('click', this.onClick);
      this.startCatalog();
    }
    startCatalog() {
      if (this.dataset.catalogOrder !== 'true' || !window.HomedockCatalogOrder
        || Number(this.dataset.currentPage || 1) !== 1) return;
      this.catalogHost = this.closest('.collection-listing');
      if (this.catalogHost?.hasAttribute('data-catalog-boot-expired')) return;
      clearTimeout(this.catalogHost?.catalogBootTimer);
      const url = new URL(location.href);
      const curated = !url.searchParams.has('sort_by') || url.searchParams.get('sort_by') === 'manual';
      const mix = curated && this.dataset.mix === 'true';
      const personalize = curated && this.dataset.personalize === 'true';
      const soldOutLast = this.dataset.soldOutLast === 'true';
      if (!mix && !personalize && !soldOutLast) {
        this.catalogHost?.removeAttribute('data-catalog-pending');
        return;
      }
      this.catalogHost?.setAttribute('data-catalog-pending', '');
      this.initialMessage = this.catalogHost?.querySelector('[data-catalog-order-loading] span');
      this.initialSpinner = this.catalogHost?.querySelector('[data-catalog-order-loading] .loading__spinner');
      this.initialRetry = this.catalogHost?.querySelector('[data-catalog-order-retry]');
      this.onInitialRetry = () => this.load();
      this.initialRetry?.addEventListener('click', this.onInitialRetry);
      this.grid.closest('#ProductGridContainer')?.classList.add('scroll-trigger--cancel');
      this.catalog = new window.HomedockCatalogOrder({
        url: url.href, sectionId: this.dataset.sectionId, mix, personalize, soldOutLast,
        availabilityFilter: this.dataset.availabilityFilter === 'true',
        margin: Number(this.dataset.priceMargin) || 25,
        api: () => window.HomedockProductInterests,
        collection: this.dataset.collectionUrl ? {
          title: this.dataset.collectionTitle, url: this.dataset.collectionUrl,
        } : null,
        fetchPage: async (pageUrl, signal) => {
          const response = await fetch(pageUrl, { signal, credentials: 'same-origin' });
          if (!response.ok) throw new Error('Unable to load catalog');
          const page = new DOMParser().parseFromString(await response.text(), 'text/html');
          const grid = page.querySelector('#product-grid');
          if (!grid) throw new Error('Missing catalog');
          return {
            items: Array.from(grid.children).filter(item => item.dataset.resultId || item.dataset.productId),
            next: page.querySelector('collection-infinite-scroll')?.dataset.nextUrl || '',
          };
        },
      });
      this.catalogInitial = true;
      this.loadCatalog();
    }
    async waitForInterests(signal) {
      if (this.dataset.personalize !== 'true') return;
      if (!window.HomedockProductInterests) {
        await new Promise(resolve => {
          const done = () => {
            clearTimeout(timer);
            document.removeEventListener('homedock:interests-changed', done);
            signal.removeEventListener('abort', done);
            resolve();
          };
          const timer = setTimeout(done, 1500);
          document.addEventListener('homedock:interests-changed', done, { once: true });
          signal.addEventListener('abort', done, { once: true });
        });
      }
      await window.HomedockProductInterests?.ready;
    }
    async loadCatalog() {
      if (this.loading || this.cancelled) return;
      this.loading = true;
      this.observer?.unobserve(this);
      this.link.hidden = true;
      this.status.textContent = 'Carregando produtos…';
      if (this.catalogInitial) {
        if (this.initialMessage) this.initialMessage.textContent = 'Carregando produtos…';
        if (this.initialSpinner) this.initialSpinner.hidden = false;
        if (this.initialRetry) this.initialRetry.hidden = true;
      }
      this.grid.setAttribute('aria-busy', 'true');
      this.controller = new AbortController();
      const controller = this.controller;
      const timeout = setTimeout(() => controller.abort(), 15000);
      let continueInitialScan = false;
      try {
        if (this.catalogInitial) await this.waitForInterests(this.controller.signal);
        if (this.cancelled || !this.isConnected) return;
        this.catalog.prepare();
        const size = matchMedia('(max-width: 749px)').matches ? 24 : 48;
        const items = await this.catalog.next(size, this.controller.signal);
        if (this.cancelled || !this.isConnected) return;
        // Never replace a card while a customer is operating its controls.
        if (this.catalogInitial && this.grid.contains(document.activeElement)) {
          this.catalog = null;
          this.updateLink();
          this.catalogHost?.removeAttribute('data-catalog-pending');
          return;
        }
        items.forEach(item => {
          item.hidden = false;
          item.removeAttribute('data-batch-hidden');
          item.classList.add('scroll-trigger--cancel');
          item.querySelectorAll('.scroll-trigger').forEach(node => node.classList.add('scroll-trigger--cancel'));
        });
        if (this.catalogInitial && (items.length || !this.catalog.hasMore)) {
          // Keep the existing lookbook and its insertion slot in the grid.
          const children = Array.from(this.grid.children);
          const extras = children.map((item, index) => ({ item, index }))
            .filter(({ item }) => !item.dataset.resultId && !item.dataset.productId);
          const ordered = [...items];
          extras.forEach(({ item, index }) => ordered.splice(Math.min(index, ordered.length), 0, item));
          this.grid.replaceChildren(...ordered);
          this.buffer = [];
          this.catalogInitial = false;
          this.catalogHost?.removeAttribute('data-catalog-pending');
        } else if (!this.catalogInitial) {
          this.grid.append(...items);
        }
        continueInitialScan = this.catalogInitial && !items.length && this.catalog.hasMore;
        this.updateLink();
      } catch (error) {
        if (!this.cancelled) {
          this.status.textContent = 'Não foi possível carregar. Tente novamente.';
          if (this.initialMessage) this.initialMessage.textContent = this.status.textContent;
          if (this.initialSpinner) this.initialSpinner.hidden = true;
          if (this.initialRetry) this.initialRetry.hidden = false;
          this.link.hidden = false;
        }
      } finally {
        clearTimeout(timeout);
        this.loading = false;
        this.grid.removeAttribute('aria-busy');
        if (continueInitialScan && !this.cancelled) setTimeout(() => this.load(), 0);
      }
    }
    stage(items) {
      const size = matchMedia('(max-width: 749px)').matches ? 24 : 48;
      this.buffer = items.slice(size);
      this.buffer.forEach((item) => { item.hidden = true; item.setAttribute('data-batch-hidden', ''); });
    }
    updateLink() {
      const more = this.catalog ? this.catalog.hasMore : this.buffer.length || this.dataset.nextUrl;
      this.link.textContent = more ? 'Ver mais' : 'Voltar ao topo';
      this.link.href = this.catalog ? (more ? this.catalog.nextUrl : '#') : this.dataset.nextUrl || '#';
      this.link.toggleAttribute('data-collection-top', !more);
      this.link.hidden = false;
      this.status.textContent = this.catalog?.scanningPrices ? 'Buscando produtos na sua faixa de preço…' : '';
      if (this.catalogInitial && this.catalog?.scanningPrices && this.initialMessage) {
        this.initialMessage.textContent = this.status.textContent;
      }
      if (more && !this.cancelled) this.observer?.observe(this);
      else this.observer?.disconnect();
    }
    cancel() {
      this.cancelled = true;
      this.controller?.abort();
      this.observer?.disconnect();
    }
    disconnectedCallback() {
      this.cancel();
      this.link?.removeEventListener('click', this.onClick);
      this.initialRetry?.removeEventListener('click', this.onInitialRetry);
    }
    async load() {
      if (this.loading || this.cancelled) return;
      if (this.catalog) return this.loadCatalog();
      this.observer?.unobserve(this);
      if (this.buffer.length && !this.cancelled) {
        const size = matchMedia('(max-width: 749px)').matches ? 24 : 48;
        this.buffer.splice(0, size).forEach((item) => { item.hidden = false; item.removeAttribute('data-batch-hidden'); });
        this.updateLink();
        return;
      }
      if (this.loading || this.cancelled || !this.dataset.nextUrl) return;
      this.loading = true;
      this.link.hidden = true;
      this.status.textContent = 'Carregando produtos…';
      this.controller = new AbortController();
      try {
        const url = new URL(this.dataset.nextUrl, location.href);
        if (url.origin !== location.origin) throw new Error('Invalid collection URL');
        url.searchParams.set('section_id', this.dataset.sectionId);
        const response = await fetch(url, { signal: this.controller.signal });
        if (!response.ok) throw new Error('Unable to load products');
        const html = await response.text();
        if (!this.isConnected || this.cancelled) return;
        const page = new DOMParser().parseFromString(html, 'text/html');
        const incoming = page.querySelector('#product-grid');
        const grid = this.closest('.collection').querySelector('#product-grid');
        if (!incoming || !grid) throw new Error('Missing product grid');
        const itemId = (item) => item.dataset.resultId || item.dataset.productId;
        const seen = new Set(Array.from(grid.children, itemId).filter(Boolean));
        const added = [];
        const fragment = document.createDocumentFragment();
        Array.from(incoming.children).forEach((item) => {
          const id = itemId(item);
          if (id && seen.has(id)) return;
          if (id) seen.add(id);
          item.classList.add('scroll-trigger--cancel');
          item.querySelectorAll('.scroll-trigger').forEach((node) => node.classList.add('scroll-trigger--cancel'));
          fragment.appendChild(item);
          added.push(item);
        });
        const next = page.querySelector('collection-infinite-scroll')?.dataset.nextUrl;
        this.dataset.nextUrl = next && next !== this.dataset.nextUrl && added.length ? next : '';
        this.stage(added);
        grid.appendChild(fragment);
        this.updateLink();
      } catch (error) {
        if (error.name !== 'AbortError' && !this.cancelled) {
          this.status.textContent = 'Não foi possível carregar. Tente novamente.';
          this.link.hidden = false;
        }
      } finally { this.loading = false; }
    }
  });
}

if (!customElements.get('collection-category-carousel')) {
  customElements.define('collection-category-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.collection-category-tiles');
      this.dots = this.querySelector('.collection-category-dots');
      this.update = () => {
        const items = Array.from(this.track.children);
        const compactPageSize = items.length > 1 ? Math.max(1, Math.floor((this.track.clientWidth + 10) / (items[1].offsetLeft - items[0].offsetLeft))) : 1;
        const perPage = matchMedia('(max-width: 749px)').matches ? 1 : this.hasAttribute('data-compact-tiles') ? compactPageSize : 3;
        const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        this.positions = [];
        for (let i = 0; i < items.length; i += perPage) {
          const position = Math.min(items[i].offsetLeft - items[0].offsetLeft, max);
          if (!this.positions.includes(position)) this.positions.push(position);
        }
        this.querySelector('.collection-category-controls').hidden = this.positions.length < 2;
        if (this.dots.children.length !== this.positions.length) {
          this.dots.replaceChildren(...this.positions.map((_, index) => {
            const dot = document.createElement('button');
            dot.type = 'button';
            dot.dataset.carouselPage = index;
            dot.setAttribute('aria-label', `Página ${index + 1} das categorias`);
            dot.setAttribute('aria-controls', this.track.id);
            return dot;
          }));
        }
        this.activePage = this.positions.reduce((best, value, index) => Math.abs(value - this.track.scrollLeft) < Math.abs(this.positions[best] - this.track.scrollLeft) ? index : best, 0);
        Array.from(this.dots.children).forEach((dot, index) => dot.setAttribute('aria-current', String(index === this.activePage)));
        this.querySelectorAll('[data-carousel-step]').forEach((button) => {
          button.disabled = Number(button.dataset.carouselStep) < 0 ? this.activePage === 0 : this.activePage === this.positions.length - 1;
        });
      };
      this.click = (event) => {
        const button = event.target.closest('[data-carousel-step], [data-carousel-page]');
        if (!button) return;
        const page = button.dataset.carouselPage !== undefined ? Number(button.dataset.carouselPage) : this.activePage + Number(button.dataset.carouselStep);
        this.track.scrollTo({ left: this.positions[Math.max(0, Math.min(page, this.positions.length - 1))], behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      };
      this.addEventListener('click', this.click);
      this.track.addEventListener('scroll', this.update, { passive: true });
      this.resize = new ResizeObserver(this.update);
      this.resize.observe(this.track);
      this.update();
    }
    disconnectedCallback() {
      this.resize?.disconnect();
      this.removeEventListener('click', this.click);
      this.track?.removeEventListener('scroll', this.update);
    }
  });
}

// Delegation also covers cards appended by scrolling or refreshed by filters.
document.addEventListener('click', (event) => {
  if (event.target.closest('[data-collection-top]')) {
    event.preventDefault();
    window.scrollTo({ top: 0, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    return;
  }
  const swatch = event.target.closest('.card__color-variants[data-image]');
  const card = swatch?.closest('.product-card-wrapper');
  if (!card || !swatch.dataset.image) return;
  card.querySelectorAll('.card__media img').forEach((image) => {
    image.src = swatch.dataset.image;
    image.srcset = swatch.dataset.image;
  });
  card.querySelectorAll('.card__color-variants').forEach((item) => {
    item.classList.toggle('card__color-variants--active', item === swatch);
    item.setAttribute('aria-pressed', String(item === swatch));
  });
});
